export default {
    setCustomers(state, customers) {
        state.customers = customers;
    },
    setCustomersPerPage(state, perPage) {
        state.customersPerPage = perPage;
    },
};
